import { render, staticRenderFns } from "./personCertifyCheckList.vue?vue&type=template&id=e787d57c&scoped=true"
import script from "./personCertifyCheckList.vue?vue&type=script&lang=js"
export * from "./personCertifyCheckList.vue?vue&type=script&lang=js"
import style0 from "./personCertifyCheckList.vue?vue&type=style&index=0&id=e787d57c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e787d57c",
  null
  
)

export default component.exports